// Corta (no redondea) a 6 decimales, hacia cero. Mismo toPrecision(15) que round6Decimals:
// sin el, 0.29 * 1e6 da 289999.99999999994 y se cortaria a 0.289999.
// El `+ 0` convierte el -0 de Math.trunc en 0.
const truncate6Decimals = (num) => {
  const factor = 10 ** 6;
  const scaled = Number((num * factor).toPrecision(15));
  return Math.trunc(scaled) / factor + 0;
};

export default truncate6Decimals
